export default __webpack_public_path__ + "static/media/bursty-logs.ecd7f5c6.gif";